import "./listfloors.css";
import { FloorsList } from "src/Components";
import API from "src/API2";
import { useState } from "react";
import toast from "react-hot-toast";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus  = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;
const IcMinus = () => <Svg><line x1="5" y1="12" x2="19" y2="12" /></Svg>;
const IcClose = () => <Svg size={18}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>;
const IcWarn  = () => <Svg size={20}><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></Svg>;

const ConfirmationModal = ({ action, onConfirm, onCancel }) => {
  const isDelete = action === "delete";
  return (
    <div className="fl-modal-overlay" onClick={onCancel}>
      <div className="fl-modal" onClick={(e) => e.stopPropagation()}>
        <header className="fl-modal__head">
          <div className="fl-modal__head-left">
            <span className={`fl-modal__icon ${isDelete ? "is-danger" : ""}`}>
              {isDelete ? <IcWarn /> : <IcPlus />}
            </span>
            <div>
              <span className={`fl-modal__eyebrow ${isDelete ? "is-warn" : ""}`}>
                {isDelete ? "Confirm deletion" : "Confirm"}
              </span>
              <h3>{isDelete ? "Delete top floor?" : "Add a new floor?"}</h3>
            </div>
          </div>
          <button className="fl-icon-btn" onClick={onCancel} aria-label="Close">
            <IcClose />
          </button>
        </header>
        <div className="fl-modal__body">
          <p className="fl-modal__text">
            {isDelete
              ? "This will remove the highest floor and any rooms assigned to it. This action cannot be undone."
              : "A new floor will be added on top of your existing floors. You can assign rooms to it afterwards."}
          </p>
        </div>
        <footer className="fl-modal__foot">
          <button className="fl-btn fl-btn--ghost" onClick={onCancel}>Cancel</button>
          <button
            className={`fl-btn ${isDelete ? "fl-btn--danger" : "fl-btn--primary"}`}
            onClick={onConfirm}
          >
            {isDelete ? (<><IcMinus /> Delete floor</>) : (<><IcPlus /> Add floor</>)}
          </button>
        </footer>
      </div>
    </div>
  );
};

const ListFloors = () => {
  const [itera, setItera] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);

  const addFloor = async () => {
    try {
      await API.post("floors");
      toast.success("Floor added");
      setItera((i) => i + 1);
    } catch (err) {
      console.error(err);
      toast.error("Could not add floor");
    }
  };

  const deleteFloor = async () => {
    try {
      await API.delete("floors");
      toast.success("Floor deleted");
      setItera((i) => i + 1);
    } catch (err) {
      console.error(err);
      toast.error("Could not delete floor");
    }
  };

  const handleModalConfirm = () => {
    if (modalAction === "add") addFloor();
    else if (modalAction === "delete") deleteFloor();
    setShowModal(false);
  };

  return (
    <div className="fl-page">
      <header className="fl-hero">
        <div>
          <span className="fl-hero__eyebrow">Property setup</span>
          <h1 className="fl-hero__title">Floors</h1>
          <p className="fl-hero__sub">
            Visualize your property floor by floor. Click any room to inspect
            availability, room type and current reservations.
          </p>
        </div>
        <div className="fl-hero__actions">
          <button
            type="button"
            className="fl-btn fl-btn--ghost-on-dark"
            onClick={() => { setModalAction("delete"); setShowModal(true); }}
          >
            <IcMinus /> Delete top floor
          </button>
          <button
            type="button"
            className="fl-btn fl-btn--primary"
            onClick={() => { setModalAction("add"); setShowModal(true); }}
          >
            <IcPlus /> Add floor
          </button>
        </div>
      </header>

      <FloorsList itera={itera} />

      {showModal && (
        <ConfirmationModal
          action={modalAction}
          onConfirm={handleModalConfirm}
          onCancel={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default ListFloors;
